import { validPhone, validLoginName, validPassword, validEmail, validURL, validNum, isValidIP, validIDCard } from "@/utils/validate";
export default {
    rulePhone(rule, value, callback) {
        if (value && !validPhone(value)) {
            callback(new Error("手机号不合法"));
        } else {
            callback();
        }
    },
};